import { render, staticRenderFns } from "./DownloadAds.vue?vue&type=template&id=5f628e29"
import script from "./DownloadAds.vue?vue&type=script&lang=js"
export * from "./DownloadAds.vue?vue&type=script&lang=js"
import style0 from "./DownloadAds.vue?vue&type=style&index=0&id=5f628e29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports